import {
    ContainerOne,
    Theatre,
} from 'elements';
import { ItemType } from 'items/models';
import * as React from 'react';
import messages from '../../displayMessages';
import { BlockPreview } from './BlockPreview';
import { BlockProps } from './models';
import {createAssetViewedEventForItem} from './utils';
import { SandboxedIFrame } from 'elements/components/SandboxedIFrame';
import { NextButton } from 'ui/components';
import { intl } from 'i18n';


export const SimulationBlock = (props: BlockProps) => {
    const [showBlockView, setShowBlockView] = React.useState(false);
    const onShow = () => {
        setShowBlockView(true);
        createAssetViewedEventForItem(props.itemMetadata.id);
    };

    // Set button title depending on simulation type
    let showButtonTitle = messages.blockSimulationStartLabel;
    if (props.itemMetadata.type === ItemType.Interactive) {
        showButtonTitle = messages.blockInteractiveStartLabel;
    }

    // Get simulation frame data from prop
    const iframeSrc = props.blockData.studentViewData.simulation_url;

    return (
        <ContainerOne>
            <BlockPreview
                previewImageUrl={props.itemMetadata.imageUrl}
                button={
                    <NextButton title={intl.formatMessage(showButtonTitle)} onClick={onShow}/>
                }
            />
            { showBlockView ? (
                <Theatre
                    title={props.itemMetadata.title}
                    onRequestClose={() => {setShowBlockView(false);}}
                >
                    <SandboxedIFrame
                        title={props.itemMetadata.title}
                        src={iframeSrc}
                        scrolling='auto'
                        width='100%'
                        onRequestClose={() => {
                            setShowBlockView(false);
                        }}
                        extraInformation={{
                            username: props.username,
                            classromName: props.classroomName,
                        }}
                    />
                </Theatre>
            ) : null}
        </ContainerOne>
    );
};
